import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchPublicPodcast } from "src/redux/actions/coaching/podcast";
import { Podcast, PodcastTranscripts } from "src/types/coaching/podcast";
import EmptyMessage from "src/components/emptyMessage";

import {
  PodcastContext,
  PodcastContextProps,
} from "src/pages/coaching/components/podcast/context";
import { PodcastSummaryComponent } from "src/pages/coaching/components/podcast";

import _ from "lodash";
import cx from "classnames";
import styles from "./podcast.module.scss";
import { enrollPodcast } from "src/redux/actions/coaching/learners";

interface EditPodcastContentProps {
  course: any;
}

export const EditPodcastContent = ({ course }: EditPodcastContentProps) => {
  const dispatch = useDispatch();
  const id = course?.content?.id;

  const podcast = useSelector((state: any) =>
    _.get(state.coaching, `podcasts.podcast[${id}].item`),
  );

  const loading = useSelector((state: any) =>
    _.get(state.coaching, `podcasts.podcast[${id}].loading`),
  );

  const podcastErrorCode = useSelector((state: any) => {
    return _.get(
      state.coaching,
      `podcasts.podcast[${id}].error.errors[0].code`,
    );
  });

  const podcastTranscripts = useSelector(
    (state: any) =>
      _.get(
        state.coaching,
        `podcasts.podcast[${id}].transcripts.item`,
      ) as PodcastTranscripts,
  );

  const [publicCourse, setPublicCourse] = useState({
    podcast: null,
  });

  const [podcastContext, setPodcastContext] =
    React.useState<PodcastContextProps>({
      id: id,
    });

  const handleEnrollPodcast = () => {
    if (podcast) {          
      dispatch(enrollPodcast({
        course: podcast.id!,
        parentCourse: course.id!,
      }));
    }
  };

  useEffect(() => {
    if (id && !podcast) {
      dispatch(fetchPublicPodcast({ id: id }));
    }
  }, [id]);

  useEffect(() => {
    if (podcast) {
      setPublicCourse((prev) => {
        return {
          ...prev,
          podcast: {
            ...podcast,
            id: podcast.id!,
            podcast: podcast,
            session: null,
            status: "ENROLLED",
          },
        };
      });
    }
  }, [podcast]);

  useEffect(() => {
    if (podcastTranscripts) {
      setPodcastContext((prev) => {
        return {
          ...prev,
          transcripts: podcastTranscripts,
        };
      });
    }
  }, [podcastTranscripts]);

  if (loading) {
    return (
      <div className={styles.loading}>
        <img src="/images/loading_plane.gif" />
        <div className={styles.message}>Loading podcast...</div>
      </div>
    );
  }

  if (!loading && !podcast) {
    return (
      <div className={styles.notFoundContainer}>
        <EmptyMessage
          width={500}
          image="/images/assets/404error_message.svg"
          heading="Mmm... who moved my cheese?"
          message="Sorry! Someone passed you the wrong information. You were never supposed to see me :). This podcast does not exist any longer."
        />
      </div>
    );
  }

  return (
    <PodcastContext.Provider value={podcastContext}>
      {publicCourse.podcast && (
        <PodcastSummaryComponent podcast={publicCourse.podcast} className={styles.podcastView} autoPlay={false} />
      )}
    </PodcastContext.Provider>
  );
};
